export default __webpack_public_path__ + "static/media/David.0dee0307.jpeg";